import React from "react";
import { ResponsiveModal } from "@UI/Components/ResponsiveModal/ResponsiveModal";
import { CircleCheck } from "@UI/Components/Icons/CircleCheck";
import { VStack } from "@UI/Components/Stack/Stack";
import { Icon } from "@UI/Components/Icon/Icon";
import { Heading } from "@UI/Components/Heading/Heading";
import { Text } from "@UI/Components/Text/Text";
import { Button } from "@UI/Components/Button/Button";
import { Box } from "@UI/Components/Box/Box";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";

import messages from "./messages";
import { PaymentMethodType } from "@modules/PaymentProcessing/types";
import { useServiceOffer } from "@modules/ServiceAssignment/hooks/useServiceOffer";

interface Props {
  isOpen: boolean;
  paymentMethod: PaymentMethodType;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleConfirm: any;
  serviceOfferId: string;
  hasNextServiceRequest?: boolean;
}

export const ConfirmationModal = ({
  isOpen,
  paymentMethod,
  handleConfirm,
  serviceOfferId,
  hasNextServiceRequest = false,
}: Props) => {
  const { serviceOffer } = useServiceOffer(serviceOfferId);
  const {
    user: { firstName },
  } = serviceOffer?.serviceProvider;
  return (
    <ResponsiveModal
      closeOnOverlayClick={false}
      closeOnEsc={false}
      isOpen={isOpen}
      closeButtonDisabled
      onClose={() => undefined}
      bodyPadding="40px"
    >
      <VStack justifyContent="center" spacing="4">
        <Icon as={CircleCheck} w="12" h="12" color="success" />
        <Heading>
          <FormattedMessage
            {...(paymentMethod === PaymentMethodType.BANK_TRANSFER
              ? messages.waitingForBankTransfer
              : messages.paymentConfirmed)}
          />
        </Heading>
        {hasNextServiceRequest ? (
          <>
            <Box w="full" bg="orange.50" borderRadius="lg" p="16px">
              <Text m="0">
                <FormattedMessage
                  {...messages.headsUpNewTask}
                  values={{ serviceProviderName: firstName }}
                />
              </Text>
            </Box>
            <Text textAlign="center">
              <FormattedMessage {...messages.acceptOrDeclineNextStep} />
            </Text>
          </>
        ) : (
          <Text textAlign="center">
            <FormattedMessage
              {...messages.paymentConfirmedInformations}
              values={{
                serviceProviderName: firstName,
              }}
            />
          </Text>
        )}
        <Button
          w="full"
          onClick={handleConfirm}
          size="lg"
          colorScheme="seaGreen"
        >
          <FormattedMessage
            {...(hasNextServiceRequest ? messages.goToTask : messages.continue)}
          />
        </Button>
      </VStack>
    </ResponsiveModal>
  );
};
